import React, { useMemo } from 'react';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { useIntl, getLocale } from 'umi';
import { processRichText } from '@/pages/intelligence/utils/richTextUtils';
import AppannieIcon from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import SensorTowerIcon from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import HatchetIcon from '@/pages/intelligence/assets/svg/dataSource/hatchet.svg';
import GoogleplayIcon from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import AppstoreIcon from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import XboxIcon from '@/pages/intelligence/assets/svg/dataSource/xbox.svg';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience.svg';
import SteamIcon from '@/pages/intelligence/assets/svg/dataSource/steam-icon.svg';
import NPDIcon from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
// import NewzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/newzoo.svg';
import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import EpicIcon from '@/pages/intelligence/assets/svg/dataSource/epic.svg';
import MetacriticIcon from '@/pages/intelligence/assets/svg/dataSource/metacritic.svg';
import OpencriticIcon from '@/pages/intelligence/assets/svg/dataSource/opencritic.svg';
// Famitsu is temporarily unavailable in Following PC&Console selectors/downloads.
// import FamitsuIcon from '@/pages/intelligence/assets/svg/dataSource/japanSales.svg';
import VginsightsIcon from '@/pages/intelligence/assets/svg/dataSource/vginsights.svg';
import GamalyticIcon from '@/pages/intelligence/assets/svg/dataSource/gamalytic.svg';
import AlineaIcon from '@/pages/intelligence/assets/svg/dataSource/alinea.svg';
import { changeTimetoDay } from '@/pages/intelligence/utils/topchartsUtils';
import { createDataSourceMetricForValue } from '@/pages/intelligence/pages/Following/_config/util';
import { getRetentionMonthlySensortowerDxHoverContent } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import { orderPCConsoleMetrics } from '@/pages/intelligence/pages/TopCharts/_config/pcConsoleMetricOrdering';

export enum SortShowType {
  SIMPLE,
  // NO_SORT,
}

export enum DisableType {
  SIMDATE_SIMMARKET, // 单天且单国家
  SIMDATE_GLOBAL, // 单天且Global
  SIMMONTH, // 单月
  ONLYMONTH, // 仅月粒度
  GLOBAL_ONLY,
  FAMITSU, // famitsu指标： (Global || japan) && weekly
  /**
    const simMarket = maketsVal.markets?.length === 1 && maketsVal.markets[0] !== 'global';
    const simTime = _apiData.start_date === _apiData.end_date; */
}

export const getActiveuserTitle = (dateType: string, formatMessage: Function) => {
  if (changeTimetoDay(dateType) === 'day') {
    return formatMessage?.({ id: `dbi_dau` });
  }
  if (changeTimetoDay(dateType) === 'week') {
    return formatMessage?.({ id: `dbi_wau` });
  }
  if (changeTimetoDay(dateType) === 'month') {
    return formatMessage?.({ id: `dbi_mau` });
  }
  return formatMessage?.({ id: `dbi_active_users` });
};
const getActiveuserMetricKey = (dateType: string) => {
  if (changeTimetoDay(dateType) === 'day') {
    return 'dau';
  }
  if (changeTimetoDay(dateType) === 'week') {
    return 'wau';
  }
  if (changeTimetoDay(dateType) === 'month') {
    return 'mau';
  }
  return 'dau';
};
export const dataSourceKey = {
  appannie: 'appannie',
  sensortower: 'sensortower',
  hatchet: 'hatchet',
  steam: 'steam',
  steamcharts: 'steamcharts',
  mscience: 'mscience',
  npd: 'npd',
  newzoo: 'newzoo',
  vginsights: 'vginsights',
  gamalytic: 'gamalytic',
  appstore: 'appstore',
  googleplay: 'googleplay',
  famitsu: 'famitsu',
  epic: 'epic',
  metacritic: 'metacritic',
  xbox: 'xbox',
  opencritic: 'opencritic',
  source_steam: 'source_steam',
  alinea: 'alinea',
};
const apiSourceKey = {
  annie_sensor: 'appannie,sensortower',
  appannie: dataSourceKey.appannie,
  sensortower: dataSourceKey.sensortower,
  hatchet: 'stream',
  steam: dataSourceKey.steam,
  steamcharts: dataSourceKey.steamcharts,
  mscience: dataSourceKey.mscience,
  npd: dataSourceKey.npd,
  newzoo: dataSourceKey.newzoo,
  newzoo_weight: 'newzoo_weight',
  rank: 'rank', // 'appstore'
  googleplay: 'googleplay',
  vginsights: dataSourceKey.vginsights,
  gamalytic: dataSourceKey.gamalytic,
  score: 'score',
  famitsu: dataSourceKey.famitsu,
  epic: dataSourceKey.epic,
  metacritic: dataSourceKey.metacritic,
  xbox: dataSourceKey.xbox,
  opencritic: dataSourceKey.opencritic,
  source_steam: dataSourceKey.source_steam,
  alinea: dataSourceKey.alinea,
};
export const useFollowingOptionList = (params: any = {}) => {
  const { dateType } = params;
  const { formatMessage } = useIntl();
  const locale = getLocale();

  const follwowingSegOptions = useMemo(() => [
    { text: formatMessage({ id: `dbi_mobile_games` }), value: 'mobile' },
    { text: formatMessage({ id: `dbi_pc_games` }), value: 'pc' },
    { text: formatMessage({ id: `dbi_console_games` }), value: 'console' },
    {
      text: formatMessage({ id: `dbi_company` }),
      value: 'company',
      noNewGame: true,
    },
  ], [locale]);

  const follwowingSegOptionsRight = useMemo(() => [
    {
      text: formatMessage({ id: `dbi_current_games` }),
      value: 'currentgames',
    },
    {
      text: formatMessage({ id: `dbi_newrelease_upcominggames` }),
      value: 'newgames',
    },
  ], [locale]);

  // cumulative_revenue: formatMessage({ id: `dbi_metric_cumulative_revenue` }),
  const tipMobile = formatMessage({ id: 'dbi_info_following_disable_mobile' });
  const tipMobileRetention = formatMessage({
    id: 'dbi_info_following_disable_retention_st',
  });
  const tipPCConsole = formatMessage({
    id: 'dbi_info_following_disable_pcconsole',
  });

  const followingEchartTitle = useMemo(() => ({
    mobile: formatMessage({ id: `dbi_mobile_games` }),
    pc: formatMessage({ id: `dbi_pc_games` }),
    console: formatMessage({ id: `dbi_console_games` }),
    company: formatMessage({ id: `dbi_company` }),
  } as any), [locale]);

  const retentionDNOptions = useMemo(
    () =>
      ['D2', 'D3', 'D7', 'D15', 'D31'].map(value => ({
        text: value,
        value,
        textContent: getRetentionMonthlySensortowerDxHoverContent(formatMessage, value),
      })),
    [locale],
  );

  // value值由对应的表格列表的datasource_metric拼成而成
  const followingChartSegmentOpts = useMemo(() => ({
    mobile: [
      {
        text: formatMessage({ id: `dbi_active_users` }),
        value: 'dau',
        metric: 'dau',
        apiSource: apiSourceKey.annie_sensor,
      },
      {
        text: formatMessage({ id: `dbi_revenue` }),
        value: 'revenue',
        metric: 'revenue',
        apiSource: apiSourceKey.annie_sensor,
      },
      {
        text: formatMessage({ id: `dbi_downloads` }),
        value: 'download',
        metric: 'download',
        apiSource: apiSourceKey.annie_sensor,
      },
      {
        text: formatMessage({ id: `dbi_retention` }),
        value: 'appannie_retention',
        metric: 'retention',
        apiSource: apiSourceKey.appannie,
      },
      {
        text: formatMessage({ id: `dbi_metric_hourswatched` }),
        value: 'stream_hoursWatched',
        metric: 'hoursWatched',
        apiSource: apiSourceKey.hatchet,
      },
      {
        text: formatMessage({ id: `dbi_metric_peakccv` }),
        value: 'stream_peackCCV',
        metric: 'peackCCV',
        apiSource: apiSourceKey.hatchet,
      },
    ],
    pc: [
      {
        text: formatMessage({ id: `dbi_pcu` }),
        value: 'source_steam_source_steam__pcu',
        metric: 'source_steam__pcu',
        apiSource: apiSourceKey.source_steam,
      },
      {
        text: formatMessage({ id: `dbi_digital_revenue` }),
        value: 'mscience_digitalRevenue',
        metric: 'digitalRevenue',
        apiSource: apiSourceKey.mscience,
      },
      {
        text: formatMessage({ id: `dbi_metric_steam_followers` }),
        value: 'vginsights_steamfollowers',
        metric: 'steamfollowers',
        apiSource: apiSourceKey.vginsights,
      },
      {
        text: formatMessage({ id: `dbi_metric_steam_reviews` }),
        value: 'alinea_alinea__steamreviews',
        metric: 'alinea__steamreviews',
        apiSource: apiSourceKey.alinea,
      },
      {
        text: formatMessage({ id: `dbi_metric_hourswatched` }),
        value: 'stream_hoursWatched',
        metric: 'hoursWatched',
        apiSource: apiSourceKey.hatchet,
      },
      {
        text: formatMessage({ id: `dbi_metric_peakccv` }),
        value: 'stream_peackCCV',
        metric: 'peackCCV',
        apiSource: apiSourceKey.hatchet,
      },
    ],
    console: [
      {
        text: formatMessage({ id: `dbi_digital_revenue` }),
        value: 'mscience_digitalRevenue',
        metric: 'digitalRevenue',
        apiSource: apiSourceKey.mscience,
      },
      {
        text: formatMessage({ id: `dbi_metric_hourswatched` }),
        value: 'stream_hoursWatched',
        metric: 'hoursWatched',
        apiSource: apiSourceKey.hatchet,
      },
      {
        text: formatMessage({ id: `dbi_metric_peakccv` }),
        value: 'stream_peackCCV',
        metric: 'peackCCV',
        apiSource: apiSourceKey.hatchet,
      },
    ],
    company: [
      {
        text: formatMessage({ id: `dbi_revenue` }),
        value: 'revenue',
        apiSource: '',
      },
      {
        text: formatMessage({ id: `dbi_downloads` }),
        value: 'download',
        apiSource: '',
      },
    ],
  } as any), [locale]);

  const mobileDataSourceRangeInfo = formatMessage({ id: `dbi_info_mobile_datasource_range` });

  /**
   *
      renderType: RenderType.RANK_AND_RATIO, 展示名次与环比
      disableType: 禁用类型;
   */
  const metricsMobile = useMemo(() => [
    {
      value: 'dau',
      apiSource: apiSourceKey.sensortower,
      dataSource: dataSourceKey.sensortower,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_active_users` }) /** 筛选框名  */,
      title: getActiveuserTitle(dateType, formatMessage) /** 表头名  */,
      svg: SensorTowerIcon,
      textContent: (
        <>
          {formatMessage({ id: `dbi_info_avg_selected` })}
          <br />
          {mobileDataSourceRangeInfo}
        </>
      ),
    },
    {
      value: 'revenue',
      apiSource: apiSourceKey.sensortower,
      dataSource: dataSourceKey.sensortower,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      title: formatMessage({ id: `dbi_revenue_$` }),
      text: formatMessage({ id: `dbi_revenue` }),
      svg: SensorTowerIcon,
      textContent: (
        <>
          {formatMessage({ id: `dbi_info_sum_selected` })}
          <br />
          {formatMessage({ id: `dbi_info_revenue_removed_new` })}
          <br />
          {mobileDataSourceRangeInfo}
        </>
      ),
    },
    {
      value: 'download',
      apiSource: apiSourceKey.sensortower,
      dataSource: dataSourceKey.sensortower,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_downloads` }),
      svg: SensorTowerIcon,
      textContent: (
        <>
          {formatMessage({ id: `dbi_info_sum_selected` })}
          <br />
          {mobileDataSourceRangeInfo}
        </>
      ),
    },
    {
      value: 'retention',
      apiSource: apiSourceKey.sensortower,
      dataSource: dataSourceKey.sensortower,
      text: formatMessage({ id: `dbi_retention` }),
      svg: SensorTowerIcon,
      renderType: RenderType.GROWTH_AND_RATIO,
      disableType: DisableType.SIMMONTH,
      disableInfo: tipMobileRetention,
      subOptions: retentionDNOptions,
      textContent: <>{mobileDataSourceRangeInfo}</>,
    },
    {
      value: 'dau' /** 后台字段值 */,
      apiSource: apiSourceKey.appannie,
      dataSource: dataSourceKey.appannie,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_active_users` }) /** 筛选框名  */,
      title: getActiveuserTitle(dateType, formatMessage) /** 表头名  */,
      svg: AppannieIcon /** 图标 */,
      renderType: RenderType.VALUE_AND_RATIO,
      textContent: (
        <>
          {formatMessage({ id: `dbi_info_avg_selected` })}
          <br />
          {mobileDataSourceRangeInfo}
        </>
      ),
      metricKey: getActiveuserMetricKey(dateType),
    },
    {
      value: 'revenue',
      apiSource: apiSourceKey.appannie,
      dataSource: dataSourceKey.appannie,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_revenue` }),
      title: formatMessage({ id: `dbi_revenue_$` }),
      svg: AppannieIcon,
      textContent: (
        <>
          {formatMessage({ id: `dbi_info_sum_selected` })}
          <br />
          {formatMessage({ id: `dbi_info_revenue_removed_new` })}
          <br />
          {mobileDataSourceRangeInfo}
        </>
      ),
    },
    {
      value: 'download',
      apiSource: apiSourceKey.appannie,
      dataSource: dataSourceKey.appannie,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_downloads` }),
      svg: AppannieIcon,
      textContent: (
        <>
          {formatMessage({ id: `dbi_info_sum_selected` })}
          <br />
          {mobileDataSourceRangeInfo}
        </>
      ),
    },
    {
      value: 'retention',
      apiSource: apiSourceKey.appannie,
      dataSource: dataSourceKey.appannie,
      text: formatMessage({ id: `dbi_retention` }),
      svg: AppannieIcon,
      renderType: RenderType.GROWTH_AND_RATIO,
      disableType: DisableType.SIMMONTH,
      disableInfo: tipMobileRetention,
      subOptions: retentionDNOptions,
      textContent: <>{mobileDataSourceRangeInfo}</>,
    },
    {
      value: 'hoursWatched',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_metric_hourswatched` }),
      svg: HatchetIcon,
      width: 238,
      width_cn: 200,
      textContent: formatMessage({ id: `dbi_info_sum_selected` }),
    },
    {
      value: 'peackCCV',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_metric_peakccv` }),
      svg: HatchetIcon,
      textContent:
          formatMessage({ id: `dbi_info_streaming_peakccv` }) +
          formatMessage({ id: `dbi_info_max_selected` }),
    },
    {
      value: 'avgCCV',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      text: formatMessage({ id: `dbi_metric_avgccv` }),
      svg: HatchetIcon,
      textContent: formatMessage({ id: `dbi_info_avg_selected` }),
    },
    {
      value: 'airtime',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      text: formatMessage({ id: `dbi_metric_airtime` }),
      svg: HatchetIcon,
      textContent: formatMessage({ id: `dbi_info_sum_selected` }),
    },
    {
      value: 'appstore top free',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.appstore,
      text: formatMessage({ id: `dbi_store_rank_top_free` }),
      svg: AppstoreIcon,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_appstore_topfree` }),
    },
    {
      value: 'appstore top paid',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.appstore,
      text: formatMessage({ id: `dbi_store_rank_top_paid` }),
      svg: AppstoreIcon,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_appstore_top_paid` }),
    },
    {
      value: 'appstore top grossing',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.appstore,
      text: formatMessage({ id: `dbi_store_rank_top_grossing` }),
      svg: AppstoreIcon,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_appstore_topgrossing` }),
    },
    {
      value: 'googleplay top free',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.googleplay,
      text: formatMessage({ id: `dbi_top_free` }),
      svg: GoogleplayIcon,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_googleplay_topfree` }),
    },
    {
      value: 'googleplay top new free',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.googleplay,
      // text: 'New Free',
      text: formatMessage({ id: `dbi_top_new_free` }),
      svg: GoogleplayIcon,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_googleplay_topnewfree` }),
    },
    {
      value: 'googleplay top paid',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.googleplay,
      text: formatMessage({ id: `dbi_top_paid` }),
      svg: GoogleplayIcon,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_googleplay_toppaid` }),
    },
    {
      value: 'googleplay top new paid',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.googleplay,
      // text: 'New Paid',
      text: formatMessage({ id: `dbi_top_new_paid` }),
      svg: GoogleplayIcon,
      // keyValue: 'rankgoogleplaytopnewpaid',
      // valueNew: 'googleplay top new paid',
      // dataSourceNew: 'rank',
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_googleplay_topnewpaid` }),
    },
    {
      value: 'googleplay top grossing',
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.googleplay,
      text: formatMessage({ id: `dbi_top_grossing` }),
      svg: GoogleplayIcon,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      textContent: formatMessage({ id: `dbi_info_googleplay_topgrossing` }),
    },
    {
      value: 'app store',
      apiSource: apiSourceKey.score,
      dataSource: dataSourceKey.appstore,
      text: formatMessage({ id: `dbi_top_ratings` }),
      svg: AppstoreIcon,
      renderType: RenderType.RATINGS,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      align: 'left',
      sortIconType: SortShowType.SIMPLE,
    },
    {
      value: 'google play',
      apiSource: apiSourceKey.score,
      dataSource: dataSourceKey.googleplay,
      text: formatMessage({ id: `dbi_top_ratings` }),
      svg: GoogleplayIcon,
      renderType: RenderType.RATINGS,
      disableType: DisableType.SIMDATE_SIMMARKET,
      disableInfo: tipMobile,
      align: 'left',
      sortIconType: SortShowType.SIMPLE,
    },
  ], [locale, dateType, mobileDataSourceRangeInfo]);

  const pcSteamSaleList = [
    // Gamalytic 指标
    {
      text: formatMessage({ id: `dbi_metric_gamalytic_steam_est_revenue` }),
      value: 'gamalytic__est_revenue',
      apiSource: apiSourceKey.gamalytic,
      dataSource: dataSourceKey.gamalytic,
      width: 380,
      textContent: processRichText(formatMessage({ id: `dbi_info_gamalytic_est_revenue` })),
      svg: GamalyticIcon,
      renderType: RenderType.VALUE_AND_RATIO,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_gamalytic_steam_est_revenue' }) },
      ),
    },
    {
      text: formatMessage({ id: `dbi_metric_gamalytic_est_price` }),
      value: 'gamalytic__est_price',
      apiSource: apiSourceKey.gamalytic,
      dataSource: dataSourceKey.gamalytic,
      width: 320,
      textContent: formatMessage({ id: `dbi_info_est_price` }),
      svg: GamalyticIcon,
      renderType: RenderType.STEAM_PRICE,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_gamalytic_est_price' }) },
      ),
    },
    // VGI 指标
    {
      // text: 'Steam Premium Revenue($)',
      text: formatMessage({ id: `dbi_metric_vgi_steam_est_revenue` }),
      value: 'est_revenue',
      apiSource: apiSourceKey.vginsights,
      dataSource: dataSourceKey.vginsights,
      width: 320,
      // titleTip: true,
      textContent: processRichText(formatMessage({ id: `dbi_info_est_revenue` })),
      svg: VginsightsIcon,
      // dataSourceName: 'vginsights',
      // dataSourceImage: vginsights,
      renderType: RenderType.VALUE_AND_RATIO,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_vgi_steam_est_revenue' }) },
      ),
    },
    {
      // text: 'Steam Units',
      text: formatMessage({ id: `dbi_metric_est_units` }),
      value: 'est_units',
      apiSource: apiSourceKey.vginsights,
      dataSource: dataSourceKey.vginsights,
      svg: VginsightsIcon,
      width: 212,
      // titleTip: true,
      textContent: processRichText(formatMessage({ id: `dbi_info_est_units` })),
      // dataSourceName: 'vginsights',
      // dataSourceImage: vginsights,
      renderType: RenderType.VALUE_AND_RATIO,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_est_units' }) },
      ),
    },
    {
      // text: 'Steam Price($)',
      text: formatMessage({ id: `dbi_metric_vgi_steam_price` }),
      value: 'est_price',
      apiSource: apiSourceKey.vginsights,
      dataSource: dataSourceKey.vginsights,
      width: 320,
      // titleTip: true,
      textContent: formatMessage({ id: `dbi_info_est_price` }),
      svg: VginsightsIcon,
      // dataSourceName: 'vginsights',
      // dataSourceImage: vginsights,
      renderType: RenderType.STEAM_PRICE,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_vgi_steam_price' }) },
      ),
    },
    {
      // text: 'Players by country',
      text: formatMessage({ id: `dbi_metric_players_by_country` }),
      // metricName: 'Players by country',
      value: 'players_by_country',
      apiSource: apiSourceKey.vginsights,
      dataSource: dataSourceKey.vginsights,
      svg: VginsightsIcon,
      textContent: formatMessage({ id: `dbi_info_players_by_country` }),
      renderType: RenderType.COUNTRY_CHART,
      width: 360,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_players_by_country' }) },
      ),
    },
    {
      // text: 'Total followers',
      text: formatMessage({ id: `dbi_metric_followers` }),
      value: 'followers',
      apiSource: apiSourceKey.vginsights,
      dataSource: dataSourceKey.vginsights,
      // metricName: 'Total followers',
      textContent: formatMessage({ id: `dbi_info_followers` }),
      renderType: RenderType.VALUE_ONLY,
      svg: VginsightsIcon,
      width: 200,
      // globalOnly: true,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_followers' }) },
      ),
    },
  ];
  const consoleJapanSalesList: any[] = [
    // Famitsu is temporarily unavailable in Following PC&Console selectors/downloads.
    // {
    //   text: formatMessage({ id: `dbi_top_sales_of_selected_time` }),
    //   value: 'famitsu_sales',
    //   apiSource: apiSourceKey.famitsu,
    //   dataSource: dataSourceKey.famitsu,
    //   svg: FamitsuIcon,
    //   disableType: DisableType.FAMITSU,
    //   disableInfo: formatMessage(
    //     { id: `dbi_info_following_disable_famitsu` },
    //     { famitsu: formatMessage({ id: 'dbi_top_sales_of_selected_time' }) },
    //   ),
    //   textContent: '',
    //   renderType: RenderType.VALUE_AND_RATIO,
    //   width: 240,
    //   width_cn: 240,
    // },
    // {
    //   text: formatMessage({ id: `dbi_top_price$` }),
    //   value: 'famitsu_price',
    //   apiSource: apiSourceKey.famitsu,
    //   dataSource: dataSourceKey.famitsu,
    //   svg: FamitsuIcon,
    //   disableType: DisableType.FAMITSU,
    //   disableInfo: formatMessage(
    //     { id: `dbi_info_following_disable_famitsu` },
    //     { famitsu: formatMessage({ id: 'dbi_top_price$' }) },
    //   ),
    //   textContent: formatMessage({ id: 'dbi_top_console_japan_sales_price_columns_tips' }),
    //   renderType: RenderType.VALUE_AND_RATIO,
    //   width: 180,
    //   width_cn: 180,
    // },
    // {
    //   text: formatMessage({ id: `dbi_top_revenue_of_selected_time$` }),
    //   value: 'famitsu_revenue',
    //   apiSource: apiSourceKey.famitsu,
    //   dataSource: dataSourceKey.famitsu,
    //   svg: FamitsuIcon,
    //   disableType: DisableType.FAMITSU,
    //   disableInfo: formatMessage(
    //     { id: `dbi_info_following_disable_famitsu` },
    //     { famitsu: formatMessage({ id: 'dbi_top_revenue_of_selected_time$' }) },
    //   ),
    //   textContent: '',
    //   renderType: RenderType.VALUE_AND_RATIO,
    //   width: 213,
    //   width_cn: 213,
    // },
    // {
    //   text: formatMessage({ id: `dbi_top_cumulative_sales_of_the_latest_week` }),
    //   value: 'famitsu_cumulative_sales',
    //   apiSource: apiSourceKey.famitsu,
    //   dataSource: dataSourceKey.famitsu,
    //   svg: FamitsuIcon,
    //   disableType: DisableType.FAMITSU,
    //   disableInfo: formatMessage(
    //     { id: `dbi_info_following_disable_famitsu` },
    //     { famitsu: formatMessage({ id: 'dbi_top_cumulative_sales_of_the_latest_week' }) },
    //   ),
    //   textContent: '',
    //   renderType: RenderType.VALUE_AND_RATIO,
    //   width: 233,
    //   width_cn: 240,
    // },
    // {
    //   text: formatMessage({ id: `dbi_top_cumulative_revenue_of_the_latest_week$` }),
    //   value: 'famitsu_cumulative_revenue',
    //   apiSource: apiSourceKey.famitsu,
    //   dataSource: dataSourceKey.famitsu,
    //   svg: FamitsuIcon,
    //   disableType: DisableType.FAMITSU,
    //   disableInfo: formatMessage(
    //     { id: `dbi_info_following_disable_famitsu` },
    //     { famitsu: formatMessage({ id: 'dbi_top_cumulative_revenue_of_the_latest_week' }) },
    //   ),
    //   textContent: '',
    //   renderType: RenderType.VALUE_AND_RATIO,
    //   width: 252,
    //   width_cn: 199,
    // },
  ];

  const metricsPCConsole = useMemo(() => [
    {
      value: 'steamfollowers',
      text: formatMessage({ id: `dbi_metric_vgi_steam_followers` }),
      svg: SteamIcon,
      icon: 'steam',
      apiSource: apiSourceKey.vginsights,
      dataSource: dataSourceKey.steam,
      textContent: formatMessage({ id: `dbi_info_steamfollowers` }),
      width: 320,
    },
    {
      value: 'gamalytic__pcu',
      text: formatMessage({ id: `dbi_metric_gamalytic_steam_pcu` }),
      svg: GamalyticIcon,
      apiSource: apiSourceKey.gamalytic,
      dataSource: dataSourceKey.gamalytic,
      textContent: formatMessage({ id: `dbi_info_gamalytic_pcu` }),
      width: 220,
    },
    {
      value: 'gamalytic__acu',
      text: formatMessage({ id: `dbi_metric_gamalytic_steam_acu` }),
      svg: GamalyticIcon,
      apiSource: apiSourceKey.gamalytic,
      dataSource: dataSourceKey.gamalytic,
      textContent: formatMessage({ id: `dbi_info_gamalytic_acu` }),
      width: 220,
    },
    {
      value: 'gamalytic__steamfollowers',
      text: formatMessage({ id: `dbi_metric_gamalytic_steam_followers` }),
      svg: GamalyticIcon,
      icon: 'gamalytic',
      apiSource: apiSourceKey.gamalytic,
      dataSource: dataSourceKey.gamalytic,
      textContent: formatMessage({ id: `dbi_info_steamfollowers` }),
      width: 320,
    },
    ...pcSteamSaleList,
    {
      value: 'gamalytic__steamreviews',
      text: formatMessage({ id: `dbi_metric_gamalytic_steam_reviews` }),
      svg: GamalyticIcon,
      icon: 'gamalytic',
      apiSource: apiSourceKey.gamalytic,
      dataSource: dataSourceKey.gamalytic,
      textContent: formatMessage({ id: `dbi_info_steamreviews` }),
      width: 320,
    },
    {
      value: 'gamalytic__cumulative_reviews',
      text: formatMessage({ id: `dbi_metric_gamalytic_steam_total_reviews` }),
      svg: GamalyticIcon,
      icon: 'gamalytic',
      apiSource: apiSourceKey.gamalytic,
      dataSource: dataSourceKey.gamalytic,
      textContent: formatMessage({ id: `dbi_info_gamalytic__cumulative_reviews` }),
      width: 280,
      renderType: RenderType.VALUE_AND_RATIO,
    },
    {
      value: 'pcu',
      text: formatMessage({ id: `dbi_metric_vgi_steam_pcu` }),
      svg: VginsightsIcon,
      icon: 'vginsights',
      apiSource: apiSourceKey.steamcharts,
      dataSource: dataSourceKey.steam,
      textContent: formatMessage({ id: `dbi_info_vgi_pcu` }),
      width: 220,
    },
    {
      value: 'acu',
      text: formatMessage({ id: `dbi_metric_vgi_steam_acu` }),
      svg: VginsightsIcon,
      icon: 'vginsights',
      apiSource: apiSourceKey.steamcharts,
      dataSource: dataSourceKey.steam,
      textContent: formatMessage({ id: `dbi_info_vgi_acu` }),
      width: 220,
    },
    {
      value: 'steamreviews',
      text: formatMessage({ id: `dbi_metric_vgi_steam_reviews` }),
      svg: VginsightsIcon,
      icon: 'vginsights',
      apiSource: apiSourceKey.vginsights,
      dataSource: dataSourceKey.vginsights,
      textContent: formatMessage({ id: `dbi_info_steamreviews` }),
      width: 320,
    },
    {
      value: 'digitalRevenue',
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_metric_digitalRevenue` }),
      // title: 'Digital Revenue($)',
      width: 220,
      svg: MscienceIcon,
      apiSource: apiSourceKey.mscience,
      dataSource: dataSourceKey.mscience,
      textContent:
          formatMessage({ id: `dbi_info_following_table_digital` }) +
          formatMessage({ id: `dbi_info_sum_selected` }),
    },
    {
      value: 'revenue',
      text: formatMessage({ id: `dbi_metric_physical_revenue` }),
      // text: 'Physical Revenue',
      // title: 'Physical Revenue($)',
      width: 220,
      svg: NPDIcon,
      apiSource: apiSourceKey.npd,
      dataSource: dataSourceKey.npd,
      textContent: formatMessage({ id: `dbi_info_sum_selected` }),
    },
    // Famitsu is temporarily unavailable in Following PC&Console selectors/downloads.
    // ...consoleJapanSalesList,
    {
      value: 'mau',
      text: formatMessage({ id: `dbi_metric_mau` }),
      svg: NewzooIcon,
      apiSource: apiSourceKey.newzoo,
      dataSource: dataSourceKey.newzoo,
      textContent: formatMessage({ id: `dbi_info_avg_selected` }),
      disableType: DisableType.ONLYMONTH,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlymonth` },
        { metric: formatMessage({ id: `dbi_metric_mau` }) },
      ),
    },
    {
      value: 'lifetime_player',
      text: formatMessage({ id: `dbi_metric_lifetime_player` }),
      svg: NewzooIcon,
      apiSource: apiSourceKey.newzoo,
      dataSource: dataSourceKey.newzoo,
      textContent: formatMessage({ id: `dbi_info_max_selected` }),
      disableType: DisableType.ONLYMONTH,
      width: 220,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlymonth` },
        { metric: formatMessage({ id: `dbi_metric_lifetime_player` }) },
      ),
    },
    {
      value: 'acquisition',
      text: formatMessage({ id: `dbi_metric_acquisition` }),
      svg: NewzooIcon,
      apiSource: apiSourceKey.newzoo_weight,
      dataSource: dataSourceKey.newzoo,
      renderType: RenderType.GROWTH_AND_RATIO,
      disableType: DisableType.ONLYMONTH,
      width: 220,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlymonth` },
        { metric: formatMessage({ id: `dbi_metric_acquisition` }) },
      ),
    },
    {
      value: 'hoursWatched',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_metric_hourswatched` }),
      svg: HatchetIcon,
      width: 238,
      width_cn: 200,
      textContent: formatMessage({ id: `dbi_info_sum_selected` }),
    },
    {
      value: 'peackCCV',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_metric_peakccv` }),
      svg: HatchetIcon,
      textContent:
          formatMessage({ id: `dbi_info_streaming_peakccv` }) +
          formatMessage({ id: `dbi_info_max_selected` }),
    },
    {
      value: 'avgCCV',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      text: formatMessage({ id: `dbi_metric_avgccv` }),
      svg: HatchetIcon,
      textContent: formatMessage({ id: `dbi_info_avg_selected` }),
      width_cn: 220,
    },
    {
      value: 'airtime',
      apiSource: apiSourceKey.hatchet,
      dataSource: dataSourceKey.hatchet,
      text: formatMessage({ id: `dbi_metric_airtime` }),
      svg: HatchetIcon,
      textContent: formatMessage({ id: `dbi_info_sum_selected` }),
    },
  ], [locale]);

  // datasource_value拼出来的值
  const pcValuessFromPCConsole = useMemo(() => [
    'gamalytic_gamalytic__pcu',
    'gamalytic_gamalytic__acu',
    'gamalytic_gamalytic__steamfollowers',
    'gamalytic_gamalytic__steamreviews',
    'gamalytic_gamalytic__cumulative_reviews',
    'steamcharts_pcu',
    'steamcharts_acu',
    'vginsights_steamfollowers',
    'vginsights_steamreviews',
    'mscience_digitalRevenue',
    'npd_revenue',
    'gamalytic_gamalytic__est_revenue',
    'gamalytic_gamalytic__est_price',
    'vginsights_est_revenue',
    'vginsights_est_unit',
    'vginsights_est_price',
    'vginsights_player_by_country',
    'vginsights_total_followers',
    'newzoo_mau',
    'newzoo_lifetime_player',
    'newzoo_weight_acquisition',
    'stream_hoursWatched',
    'stream_peackCCV',
    'stream_avgCCV',
    'stream_airtime',
  ], [locale]);

  const consoleValuessFromPCConsole = useMemo(() => [
    // Console Games 不支持 Gamalytic 数据，移除相关指标
    'steamcharts_pcu',
    'steamcharts_acu',
    'vginsights_steamfollowers',
    'vginsights_steamreviews',
    'mscience_digitalRevenue',
    'npd_revenue',
    // Famitsu is temporarily unavailable in Following PC&Console selectors/downloads.
    // 'famitsu_famitsu_sales',
    // 'famitsu_famitsu_price',
    // 'famitsu_famitsu_revenue',
    // 'famitsu_famitsu_cumulative_sales',
    // 'famitsu_famitsu_cumulative_revenue',
    'newzoo_mau',
    'newzoo_lifetime_player',
    'newzoo_weight_acquisition',
    'stream_hoursWatched',
    'stream_peackCCV',
    'stream_avgCCV',
    'stream_airtime',
  ], [locale]);

  const pcOptionsFromPCConsole = metricsPCConsole.filter((item) =>
    pcValuessFromPCConsole.includes(createDataSourceMetricForValue(item?.value, item?.apiSource)),
  );

  const consoleOptionsFromPCConsole = metricsPCConsole.filter((item) =>
    consoleValuessFromPCConsole.includes(
      createDataSourceMetricForValue(item?.value, item?.apiSource),
    ),
  );

  const alineaSteamMetrics = useMemo(() => [
    {
      value: 'alinea__pcu',
      text: formatMessage({ id: `dbi_metric_alinea_steam_pcu` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea_pcu` }),
      width: 220,
    },
    {
      value: 'alinea__acu',
      text: formatMessage({ id: `dbi_metric_alinea_steam_acu` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea_acu` }),
      width: 220,
    },
    {
      value: 'alinea__steamfollowers',
      text: formatMessage({ id: `dbi_metric_alinea_steam_followers` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea__steamfollowers` }),
      width: 220,
    },
    {
      text: formatMessage({ id: `dbi_metric_alinea_est_price` }),
      value: 'alinea__est_price',
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      width: 320,
      textContent: formatMessage({ id: `dbi_info_alinea_est_price` }),
      svg: AlineaIcon,
      renderType: RenderType.STEAM_PRICE,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_alinea_est_price' }) },
      ),
    },
    {
      value: 'alinea__steamreviews',
      text: formatMessage({ id: `dbi_metric_alinea_steam_reviews` }),
      checkDefault: true,
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea__steamreviews` }),
      width: 220,
    },
    {
      value: 'alinea__cumulative_reviews',
      text: formatMessage({ id: `dbi_metric_alinea_steam_total_reviews` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea__cumulative_reviews` }),
      width: 280,
      renderType: RenderType.VALUE_AND_RATIO,
    },
    {
      value: 'alinea__positive',
      text: formatMessage({ id: `dbi_metric_alinea_steam_positive_reviews` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea__positive` }),
      width: 280,
      renderType: RenderType.VALUE_AND_RATIO,
    },
    {
      value: 'alinea__cumulative_positive',
      text: formatMessage({ id: `dbi_metric_alinea_steam_total_positive_reviews` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea__cumulative_positive` }),
      width: 320,
      renderType: RenderType.VALUE_AND_RATIO,
    },
    {
      value: 'alinea__est_revenue',
      checkDefault: true,
      text: formatMessage({ id: `dbi_metric_alinea_est_revenue` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: processRichText(formatMessage({ id: `dbi_info_alinea_est_revenue` })),
      width: 320,
      renderType: RenderType.VALUE_AND_RATIO,
      disableType: DisableType.GLOBAL_ONLY,
      disableInfo: formatMessage(
        { id: `dbi_info_following_disable_onlyglobal` },
        { metric: formatMessage({ id: 'dbi_metric_alinea_est_revenue' }) },
      ),
    },
    {
      value: 'alinea__players',
      text: formatMessage({ id: `dbi_metric_alinea_steam_players` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea__players` }),
      width: 220,
      renderType: RenderType.VALUE_AND_RATIO,
    },
    {
      value: 'alinea__players_total',
      text: formatMessage({ id: `dbi_metric_alinea_steam_total_players` }),
      svg: AlineaIcon,
      apiSource: apiSourceKey.alinea,
      dataSource: dataSourceKey.alinea,
      textContent: formatMessage({ id: `dbi_info_alinea__players_total` }),
      width: 240,
      renderType: RenderType.VALUE_AND_RATIO,
    },
  ], [locale]);
  
  const metricsPC = useMemo(() => [
    {
      value: 'source_steam__pcu',
      checkDefault: true,
      text: formatMessage({ id: `dbi_metric_source_steam_pcu` }),
      svg: SteamIcon,
      icon: 'source_steam',
      apiSource: apiSourceKey.source_steam,
      dataSource: dataSourceKey.source_steam,
      textContent: formatMessage({ id: `dbi_info_source_steam_pcu` }),
      width: 220,
    },
    {
      value: 'source_steam__acu',
      checkDefault: true,
      text: formatMessage({ id: `dbi_metric_source_steam_acu` }),
      svg: SteamIcon,
      icon: 'source_steam',
      apiSource: apiSourceKey.source_steam,
      dataSource: dataSourceKey.source_steam,
      textContent: formatMessage({ id: `dbi_info_source_steam_acu` }),
      width: 220,
    },
    // ...(() => {
    //   const idx = pcOptionsFromPCConsole.findIndex(
    //     (item) => item?.value === 'steamfollowers' && item?.apiSource === apiSourceKey.vginsights,
    //   );
    //   if (idx === -1) return [...pcOptionsFromPCConsole, ...alineaSteamMetrics];
    //   return [
    //     ...pcOptionsFromPCConsole.slice(0, idx + 1),
    //     ...alineaSteamMetrics,
    //     ...pcOptionsFromPCConsole.slice(idx + 1),
    //   ];
    // })(),
    ...pcOptionsFromPCConsole,
    ...alineaSteamMetrics,
    {
      value: 'steam top sellers',
      // text: 'Top Sellers',
      text: formatMessage({ id: `dbi_store_rank_top_sellers` }),
      svg: SteamIcon,
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.steam,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      textContent: formatMessage({ id: `dbi_info_steam_topsellers` }),
    },
    {
      value: 'steam top wish lists',
      // text: 'Top Wish Lists',
      text: formatMessage({ id: `dbi_store_rank_top_wish_lists` }),
      svg: SteamIcon,
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.steam,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      width: 200,
      textContent: formatMessage({ id: `dbi_info_steam_topwishlists` }),
    },
    {
      value: 'steam new and trending',
      // text: 'New and Trending',
      text: formatMessage({ id: `dbi_store_rank_new_and_trending` }),
      svg: SteamIcon,
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.steam,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      textContent: formatMessage({ id: `dbi_info_steam_newtrending` }),
      width: 240,
      width_cn: 220,
    },
    {
      value: 'epic top sellers',
      text: formatMessage({ id: `dbi_store_rank_top_sellers` }),
      svg: EpicIcon,
      apiSource: apiSourceKey.rank,
      dataSource: 'epic',
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      textContent: formatMessage({ id: `dbi_info_epic_topsellers` }),
    },
    {
      value: 'epic top popular',
      text: formatMessage({ id: `dbi_store_rank_top_popular` }),
      svg: EpicIcon,
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.epic,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      textContent: formatMessage({ id: `dbi_info_epic_toppopular` }),
    },
    {
      value: 'steam',
      text: 'Steam', // 无需翻译
      svg: SteamIcon,
      apiSource: apiSourceKey.score,
      dataSource: dataSourceKey.steam,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      renderType: RenderType.GROWTH_AND_RATIO,
      sortIconType: SortShowType.SIMPLE,
    },
    {
      value: 'metacritic',
      text: 'MetaCritic', // 无需翻译
      svg: MetacriticIcon,
      apiSource: apiSourceKey.score,
      dataSource: dataSourceKey.metacritic,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      sortIconType: SortShowType.SIMPLE,
    },
  ], [locale]);

  const metricsConsole = useMemo(() => [
    ...consoleOptionsFromPCConsole,
    {
      value: 'xbox new release',
      text: formatMessage({ id: `dbi_store_rank_new_release` }),
      svg: XboxIcon,
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.xbox,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      textContent: formatMessage({ id: `dbi_info_xbox_newrelease` }),
    },
    {
      value: 'xbox upcoming',
      // text: 'Xbox Upcoming',
      text: formatMessage({ id: `dbi_top_xbox_upcoming` }),
      svg: XboxIcon,
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.xbox,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      textContent: formatMessage({ id: `dbi_info_xbox_upcoming` }),
    },
    {
      value: 'xbox most played',
      // text: 'Xbox Most Played',
      text: formatMessage({ id: `dbi_top_xbox_most_played` }),
      svg: XboxIcon,
      apiSource: apiSourceKey.rank,
      dataSource: dataSourceKey.xbox,
      renderType: RenderType.RANK_AND_RATIO,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      textContent: formatMessage({ id: `dbi_info_xbox_mostplayed` }),
    },
    {
      value: 'opencritic',
      text: 'OpenCritic', // 无需翻译
      svg: OpencriticIcon,
      apiSource: apiSourceKey.score,
      dataSource: dataSourceKey.opencritic,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      renderType: RenderType.GROWTH_AND_RATIO,
      sortIconType: SortShowType.SIMPLE,
    },
    {
      value: 'metacritic',
      text: 'MetaCritic', // 无需翻译
      svg: MetacriticIcon,
      apiSource: apiSourceKey.score,
      dataSource: dataSourceKey.metacritic,
      disableType: DisableType.SIMDATE_GLOBAL,
      disableInfo: tipPCConsole,
      sortIconType: SortShowType.SIMPLE,
    },
  ], [locale]);

  const metricsCompany = useMemo(() => [
    {
      value: 'revenue',
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_revenue` }),
      title: formatMessage({ id: `dbi_revenue_$` }),
      svg: AppannieIcon,
      apiSource: '',
      dataSource: dataSourceKey.appannie,
    },
    {
      value: 'download',
      checkDefault: true, // 用于Metrics筛选器的默认勾选值
      text: formatMessage({ id: `dbi_downloads` }),
      svg: AppannieIcon,
      apiSource: '',
      dataSource: dataSourceKey.appannie,
    },
  ], [locale]);

  const changeValue = (item) => ({
    ...(item || {}),
    key: createDataSourceMetricForValue(item?.value, item?.apiSource),
  });

  const getObj = (list) => {
    const obj: any = {
      allList: list,
      allListChangeValue: [],
      defaultMetricList: [],
      defaultMetricValues: [],
    };
    list.forEach((item) => {
      const _item = changeValue(item);
      obj.allListChangeValue.push(_item);
      if (_item.checkDefault) {
        obj.defaultMetricList.push(_item);
        obj.defaultMetricValues.push(_item.key);
      }
    });
    return obj;
  };
  const orderedMetricsPC = [
    ...orderPCConsoleMetrics(
      metricsPC.filter((item) => ![apiSourceKey.rank, apiSourceKey.score].includes(item?.apiSource)),
      'icon',
    ),
    ...metricsPC.filter((item) => [apiSourceKey.rank, apiSourceKey.score].includes(item?.apiSource)),
  ];
  const followListObj: any = {
    mobile: getObj(metricsMobile),
    pc: getObj(orderedMetricsPC),
    console: getObj(metricsConsole),
    company: getObj(metricsCompany),
  };

  return {
    followListObj,
    followingChartSegmentOpts,
    retentionDNOptions,
    followingEchartTitle,
    follwowingSegOptions,
    follwowingSegOptionsRight,
    consoleJapanSalesList,
  };
};
